var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner",class:{ white: _vm.color === 'white' }},[_c('div',{staticClass:"spinner-a"}),_c('div',{staticClass:"spinner-b"}),_c('div',{staticClass:"spinner-c"})])}
var staticRenderFns = []

export { render, staticRenderFns }